import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box, Typography, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Dialog,
  DialogTitle, DialogContent, DialogActions, TextField, IconButton
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';

const API = process.env.REACT_APP_API_URL || '';

const estiloTabla = {
  bgcolor: 'var(--c-superficie)',
  '& .MuiTableCell-root': { color: '#e0e0e0', borderColor: 'var(--c-primario)' }
};

export default function Especialidades() {
  const [lista, setLista] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editando, setEditando] = useState(null);
  const [nombre, setNombre] = useState('');
  const [error, setError] = useState('');

  useEffect(() => { cargar(); }, []);

  async function cargar() {
    try {
      const r = await axios.get(`${API}/api/especialidades`);
      setLista(r.data);
    } catch (err) { console.error(err); }
  }

  function abrirNuevo() {
    setEditando(null);
    setNombre('');
    setError('');
    setDialogOpen(true);
  }

  function abrirEditar(esp) {
    setEditando(esp.id);
    setNombre(esp.nombre);
    setError('');
    setDialogOpen(true);
  }

  async function guardar() {
    if (!nombre.trim()) { setError('El nombre es obligatorio'); return; }
    try {
      if (editando) {
        await axios.put(`${API}/api/especialidades/${editando}`, { nombre });
      } else {
        await axios.post(`${API}/api/especialidades`, { nombre });
      }
      setDialogOpen(false);
      cargar();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al guardar');
    }
  }

  async function eliminar(id) {
    if (!window.confirm('¿Eliminar esta especialidad?')) return;
    try {
      await axios.delete(`${API}/api/especialidades/${id}`);
      cargar();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al eliminar');
    }
  }

  const fieldSx = { '& .MuiOutlinedInput-root fieldset': { borderColor: 'var(--c-primario)' } };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <MedicalServicesIcon sx={{ color: 'var(--c-acento)' }} />
          <Typography variant="h5" sx={{ fontWeight: 700, color: 'var(--c-acento)' }}>
            Especialidades
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} onClick={abrirNuevo}
          sx={{ bgcolor: 'var(--c-primario)', '&:hover': { bgcolor: 'var(--c-primario)' } }}>
          Nueva especialidad
        </Button>
      </Box>

      <TableContainer component={Paper} sx={estiloTabla}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: 'var(--c-primario)' }}>
              <TableCell>Nombre</TableCell>
              <TableCell align="right">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lista.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center" sx={{ color: '#b0b0b0', py: 4 }}>
                  No hay especialidades registradas. Creá la primera.
                </TableCell>
              </TableRow>
            ) : lista.map(esp => (
              <TableRow key={esp.id} sx={{ '&:hover': { bgcolor: 'var(--c-primario)' } }}>
                <TableCell sx={{ fontWeight: 500 }}>{esp.nombre}</TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => abrirEditar(esp)} sx={{ color: 'var(--c-acento)' }}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton onClick={() => eliminar(esp.id)} sx={{ color: '#f48fb1' }}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}
        PaperProps={{ sx: { bgcolor: 'var(--c-superficie)', color: '#e0e0e0' } }}>
        <DialogTitle>{editando ? 'Editar especialidad' : 'Nueva especialidad'}</DialogTitle>
        <DialogContent sx={{ mt: 1, minWidth: 320 }}>
          <TextField
            label="Nombre *" fullWidth autoFocus value={nombre}
            onChange={e => { setNombre(e.target.value); setError(''); }}
            onKeyPress={e => e.key === 'Enter' && guardar()}
            InputLabelProps={{ style: { color: 'var(--c-acento)' } }}
            inputProps={{ style: { color: '#e0e0e0' } }}
            sx={fieldSx}
            placeholder="Ej: Clínica médica, Pediatría, Cardiología..."
          />
          {error && (
            <Typography sx={{ color: '#f44336', fontSize: 13, mt: 1 }}>{error}</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} sx={{ color: 'var(--c-acento)' }}>Cancelar</Button>
          <Button onClick={guardar} variant="contained"
            sx={{ bgcolor: 'var(--c-primario)', '&:hover': { bgcolor: 'var(--c-primario)' } }}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
